/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crash_TitleInputs */

const th_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้านี้หยุดทำงาน`)
};

const en_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page stopped working`)
};

const ja_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このページは動作を停止しました`)
};

const zh_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此页面已停止工作`)
};

const es_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página ha dejado de funcionar`)
};

const pt_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página parou de funcionar`)
};

const id_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini berhenti bekerja`)
};

const fr_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page a cessé de fonctionner`)
};

const tl_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huminto sa paggana ang pahinang ito`)
};

const vi_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang này đã ngừng hoạt động`)
};

const ko_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지가 작동을 멈췄습니다`)
};

const de_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite funktioniert nicht mehr`)
};

const ru_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта страница перестала работать`)
};

const tr_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sayfa çalışmayı durdurdu`)
};

const it_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa pagina ha smesso di funzionare`)
};

const pl_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta strona przestała działać`)
};

const uk_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця сторінка перестала працювати`)
};

const hi_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह पृष्ठ काम करना बंद कर चुका है`)
};

const ar_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`توقفت هذه الصفحة عن العمل`)
};

const ms_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini berhenti berfungsi`)
};

const bn_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই পৃষ্ঠাটি কাজ করা বন্ধ করেছে`)
};

const zh_tw2_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個頁面已停止運作`)
};

const zh_hk2_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個頁面已停止運作`)
};

const ur_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ صفحہ کام کرنا بند کر چکا ہے`)
};

const fa_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این صفحه از کار افتاده است`)
};

const sw_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukurasa huu umeacha kufanya kazi`)
};

const nl_crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze pagina werkt niet meer`)
};

/**
* | output |
* | --- |
* | "This page stopped working" |
*
* @param {Crash_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const crash_title = /** @type {((inputs?: Crash_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crash_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_crash_title(inputs)
	if (locale === "ja") return ja_crash_title(inputs)
	if (locale === "zh") return zh_crash_title(inputs)
	if (locale === "es") return es_crash_title(inputs)
	if (locale === "pt") return pt_crash_title(inputs)
	if (locale === "id") return id_crash_title(inputs)
	if (locale === "fr") return fr_crash_title(inputs)
	if (locale === "tl") return tl_crash_title(inputs)
	if (locale === "vi") return vi_crash_title(inputs)
	if (locale === "ko") return ko_crash_title(inputs)
	if (locale === "de") return de_crash_title(inputs)
	if (locale === "ru") return ru_crash_title(inputs)
	if (locale === "tr") return tr_crash_title(inputs)
	if (locale === "it") return it_crash_title(inputs)
	if (locale === "pl") return pl_crash_title(inputs)
	if (locale === "uk") return uk_crash_title(inputs)
	if (locale === "hi") return hi_crash_title(inputs)
	if (locale === "ar") return ar_crash_title(inputs)
	if (locale === "ms") return ms_crash_title(inputs)
	if (locale === "bn") return bn_crash_title(inputs)
	if (locale === "zh-TW") return zh_tw2_crash_title(inputs)
	if (locale === "zh-HK") return zh_hk2_crash_title(inputs)
	if (locale === "ur") return ur_crash_title(inputs)
	if (locale === "fa") return fa_crash_title(inputs)
	if (locale === "sw") return sw_crash_title(inputs)
	if (locale === "nl") return nl_crash_title(inputs)
	return en_crash_title(inputs)
});